import React from "react";

export default function CalendarIcon({ className = "svg-308", ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true" {...props}>
      <rect width="20" height="20" rx="10" fill="#F0FDF4" />
      <path
        d="M12.3333 7.08333C12.3333 6.54085 12.3333 6.26961 12.2737 6.04707C12.1119 5.44316 11.6402 4.97145 11.0363 4.80963C10.8137 4.75 10.5425 4.75 10 4.75C9.45752 4.75 9.18628 4.75 8.96374 4.80963C8.35983 4.97145 7.88812 5.44316 7.7263 6.04707C7.66667 6.26961 7.66667 6.54085 7.66667 7.08333M6.03334 15.25H13.9667C14.6201 15.25 14.9468 15.25 15.1963 15.1228C15.4159 15.011 15.5943 14.8325 15.7062 14.613C15.8333 14.3634 15.8333 14.0367 15.8333 13.3833V8.95C15.8333 8.29661 15.8333 7.96991 15.7062 7.72034C15.5943 7.50082 15.4159 7.32234 15.1963 7.21049C14.9468 7.08333 14.6201 7.08333 13.9667 7.08333H6.03334C5.37994 7.08333 5.05325 7.08333 4.80368 7.21049C4.58416 7.32234 4.40568 7.50082 4.29383 7.72034C4.16667 7.96991 4.16667 8.29661 4.16667 8.95V13.3833C4.16667 14.0367 4.16667 14.3634 4.29383 14.613C4.40568 14.8325 4.58416 15.011 4.80368 15.1228C5.05325 15.25 5.37994 15.25 6.03334 15.25Z"
        stroke="#16A34A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
